var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      staticClass: "select-student-dialog",
      attrs: { "max-width": "900px", fullscreen: _vm.isMobile },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-btn",
        {
          staticClass: "main-action-button active",
          attrs: { slot: "activator", dark: "", block: "" },
          slot: "activator"
        },
        [
          _c("v-icon", { staticClass: "pr-3" }, [_vm._v("create")]),
          _vm._v("\n    Create Service Log\n  ")
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isMobile
        ? _c(
            "v-card",
            { staticStyle: { overflow: "hidden" } },
            [
              _c(
                "v-toolbar",
                { attrs: { color: "primary", dark: "" } },
                [
                  _vm.isAdmin && !_vm.showSelectStudents
                    ? _c("v-toolbar-title", [
                        _vm._v("\n        Select Provider\n      ")
                      ])
                    : _c("v-toolbar-title", [
                        _vm.isMobile
                          ? _c("span", [
                              _vm._v("\n            Select Service\n          ")
                            ])
                          : _c("span", [
                              _vm._v(
                                "\n            Select Student Service\n          "
                              )
                            ])
                      ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _vm.showSelectStudents
                    ? _c(
                        "div",
                        { staticStyle: { "padding-top": "20px" } },
                        [
                          _c(
                            "v-tooltip",
                            { attrs: { disabled: !_vm.showTooltip, top: "" } },
                            [
                              _c(
                                "v-switch",
                                {
                                  attrs: { slot: "activator" },
                                  slot: "activator",
                                  model: {
                                    value: _vm.allSupportsToggle,
                                    callback: function($$v) {
                                      _vm.allSupportsToggle = $$v
                                    },
                                    expression: "allSupportsToggle"
                                  }
                                },
                                [
                                  _c("template", { slot: "label" }, [
                                    _c(
                                      "span",
                                      {
                                        class: {
                                          "accent--text font-weight-bold":
                                            _vm.allSupportsToggle,
                                          small: _vm.isMobile
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  All Services\n                "
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v("View Current Services or All Services")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isMobile
                    ? _c(
                        "span",
                        [
                          _c(
                            "v-icon",
                            {
                              on: {
                                click: function($event) {
                                  _vm.dialog = false
                                }
                              }
                            },
                            [_vm._v("close")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card",
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "", "text-xs-left": "" } },
                    [
                      _vm.isAdmin && !_vm.showSelectStudents
                        ? [
                            _c(
                              "v-card-text",
                              [
                                _c(
                                  "v-layout",
                                  {
                                    attrs: {
                                      row: "",
                                      "justify-center": "",
                                      "align-center": ""
                                    }
                                  },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs12: "", sm6: "" } },
                                      [
                                        _c(
                                          "v-autocomplete",
                                          {
                                            attrs: {
                                              dense: "",
                                              label:
                                                "Provider Name/Credentials",
                                              placeholder: "Enter Provider",
                                              items: _vm.providersArray,
                                              clearable: true,
                                              "error-messages":
                                                _vm.providerSearchError,
                                              "return-object": true,
                                              "search-input":
                                                _vm.providerSearchInput,
                                              "item-text": "username",
                                              loading:
                                                _vm.providerSearchLoading,
                                              "no-filter": true
                                            },
                                            on: {
                                              "update:searchInput": function(
                                                $event
                                              ) {
                                                _vm.providerSearchInput = $event
                                              },
                                              "update:search-input": function(
                                                $event
                                              ) {
                                                _vm.providerSearchInput = $event
                                              },
                                              focus:
                                                _vm.clearProvidersAutoComplete
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "item",
                                                  fn: function(ref) {
                                                    var item = ref.item
                                                    var tile = ref.tile
                                                    return [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            item.firstName
                                                          ) +
                                                          " " +
                                                          _vm._s(
                                                            item.lastName
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                      _vm._v(" "),
                                                      item.credentialName
                                                        ? _c("span", [
                                                            _vm._v(
                                                              "/" +
                                                                _vm._s(
                                                                  item.credentialName
                                                                )
                                                            )
                                                          ])
                                                        : _vm._e()
                                                    ]
                                                  }
                                                },
                                                {
                                                  key: "selection",
                                                  fn: function(ref) {
                                                    var item = ref.item
                                                    var selected = ref.selected
                                                    return [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            item.firstName
                                                          ) +
                                                          " " +
                                                          _vm._s(
                                                            item.lastName
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                      _vm._v(" "),
                                                      item.credentialName
                                                        ? _c("span", [
                                                            _vm._v(
                                                              "/" +
                                                                _vm._s(
                                                                  item.credentialName
                                                                )
                                                            )
                                                          ])
                                                        : _vm._e()
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              false,
                                              151473153
                                            ),
                                            model: {
                                              value: _vm.selectedProvider,
                                              callback: function($$v) {
                                                _vm.selectedProvider = $$v
                                              },
                                              expression: "selectedProvider"
                                            }
                                          },
                                          [
                                            _vm._v(" "),
                                            _vm._v(" "),
                                            _c(
                                              "template",
                                              { slot: "no-data" },
                                              [
                                                _c(
                                                  "v-list",
                                                  [
                                                    !_vm.providerSearchInput
                                                      ? _c("v-list-tile", [
                                                          _vm._v(
                                                            "\n                        Please type a Provider.\n                      "
                                                          )
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.providerSearchInput &&
                                                    !_vm.providerSearchLoading
                                                      ? _c("v-list-tile", [
                                                          _vm._v(
                                                            "\n                        No Results\n                      "
                                                          )
                                                        ])
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-end": "" } },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          color: "secondary",
                                          disabled: !_vm.selectedProvider
                                        },
                                        on: { click: _vm.goToSelectStudents }
                                      },
                                      [
                                        _vm._v(
                                          "\n                Select Student\n                "
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "pl-2" },
                                          [
                                            _c("v-icon", [
                                              _vm._v("mdi-arrow-right")
                                            ])
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isAdmin || (_vm.showSelectStudents && _vm.isAdmin)
                        ? [
                            _c(
                              "div",
                              { staticClass: "student-info" },
                              [
                                _c(
                                  "v-card-title",
                                  {
                                    staticClass: "py-0",
                                    staticStyle: { position: "relative" }
                                  },
                                  [
                                    _c(
                                      "v-layout",
                                      { attrs: { row: "", wrap: "" } },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { xs12: "", sm4: "" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: "Find Student",
                                                placeholder: "Enter Student",
                                                clearable: true
                                              },
                                              model: {
                                                value: _vm.findStudentSearch,
                                                callback: function($$v) {
                                                  _vm.findStudentSearch = $$v
                                                },
                                                expression: "findStudentSearch"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { xs12: "", sm4: "" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: "Filter School",
                                                placeholder: "Enter School",
                                                clearable: true
                                              },
                                              model: {
                                                value: _vm.findSchoolSearch,
                                                callback: function($$v) {
                                                  _vm.findSchoolSearch = $$v
                                                },
                                                expression: "findSchoolSearch"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { xs12: "", sm4: "" } },
                                          [
                                            _c(
                                              "v-layout",
                                              { attrs: { row: "", wrap: "" } },
                                              [
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs6: "" } },
                                                  [
                                                    _c(
                                                      "v-menu",
                                                      {
                                                        staticStyle: {
                                                          width: "100%"
                                                        },
                                                        attrs: {
                                                          "open-on-hover": "",
                                                          "offset-y": ""
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              slot: "activator",
                                                              color:
                                                                "secondary",
                                                              block: ""
                                                            },
                                                            slot: "activator"
                                                          },
                                                          [
                                                            _c("small", [
                                                              _vm._v("Sort")
                                                            ])
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-list",
                                                          [
                                                            _c(
                                                              "v-list-tile",
                                                              [
                                                                _c(
                                                                  "v-list-tile-title",
                                                                  {
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        _vm.sort =
                                                                          "lastNameAsc"
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                              Last Name Asc\n                            "
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "v-list-tile",
                                                              [
                                                                _c(
                                                                  "v-list-tile-title",
                                                                  {
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        _vm.sort =
                                                                          "lastNameDesc"
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                              Last Name Desc\n                            "
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "v-list-tile",
                                                              [
                                                                _c(
                                                                  "v-list-tile-title",
                                                                  {
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        _vm.sort =
                                                                          "schoolAsc"
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                              School Name Asc\n                            "
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "v-list-tile",
                                                              [
                                                                _c(
                                                                  "v-list-tile-title",
                                                                  {
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        _vm.sort =
                                                                          "schoolDesc"
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                              School Name Desc\n                            "
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "v-list-tile",
                                                              [
                                                                _c(
                                                                  "v-list-tile-title",
                                                                  {
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        _vm.sort =
                                                                          "latestService"
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                              Last Service\n                            "
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs6: "" } },
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          color: "secondary",
                                                          block: ""
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            _vm.checkAllBoxes = !_vm.checkAllBoxes
                                                          }
                                                        }
                                                      },
                                                      [
                                                        !_vm.checkAllBoxes
                                                          ? _c("small", [
                                                              _vm._v(
                                                                "Select All"
                                                              )
                                                            ])
                                                          : _c("small", [
                                                              _vm._v(
                                                                "Deselect All"
                                                              )
                                                            ])
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-container",
                                  {
                                    staticClass: "pa-0",
                                    attrs: { "text-xs-left": "" }
                                  },
                                  [
                                    _c(
                                      "v-alert",
                                      {
                                        attrs: {
                                          value: !_vm.filteredStudents.length,
                                          type: "error"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                No Students associated with this provider.\n              "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.filteredStudents.length
                                      ? _c("v-data-table", {
                                          staticClass: "student-container",
                                          attrs: {
                                            items: _vm.filteredStudents,
                                            "hide-actions": "",
                                            "hide-headers": ""
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "items",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "td",
                                                      [
                                                        _c("v-checkbox", {
                                                          attrs: {
                                                            color: "secondary",
                                                            "hide-details": ""
                                                          },
                                                          model: {
                                                            value:
                                                              props.item
                                                                .selected,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                props.item,
                                                                "selected",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "props.item.selected"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        class: {
                                                          "warning--text": !props
                                                            .item.active
                                                        }
                                                      },
                                                      [
                                                        _c("strong", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.item
                                                                .studentName
                                                            )
                                                          )
                                                        ]),
                                                        _c("br"),
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              props.item
                                                                .studentExtId
                                                            ) +
                                                            "\n                  "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        class: {
                                                          "warning--text": !props
                                                            .item.active
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              props.item
                                                                .schoolName
                                                            ) +
                                                            " (" +
                                                            _vm._s(
                                                              props.item.grade
                                                            ) +
                                                            ")"
                                                        ),
                                                        _c("br"),
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              props.item
                                                                .serviceName
                                                            ) +
                                                            "\n                  "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        class: {
                                                          "warning--text": !props
                                                            .item.active
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatDate"
                                                              )(
                                                                props.item
                                                                  .startDate
                                                              )
                                                            ) +
                                                            " - " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatDate"
                                                              )(
                                                                props.item
                                                                  .endDate
                                                              )
                                                            )
                                                        ),
                                                        _c("br"),
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              props.item
                                                                .frequency
                                                            ) +
                                                            " "
                                                        ),
                                                        props.item.esy
                                                          ? _c("span", [
                                                              _vm._v("(ESY)")
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            3979485016
                                          )
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c(
                                  "v-layout",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: { "mx-0": "", "mt-3": "" }
                                  },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        staticClass: "block",
                                        attrs: { xs14: "" }
                                      },
                                      [
                                        _c(
                                          "v-layout",
                                          { attrs: { row: "", wrap: "" } },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs6: "" } },
                                              [
                                                _vm.isAdmin
                                                  ? _c(
                                                      "v-btn",
                                                      {
                                                        staticClass: "my-0",
                                                        attrs: {
                                                          color: "secondary"
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.returnToProviders
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass: "pr-2"
                                                          },
                                                          [
                                                            _c("v-icon", [
                                                              _vm._v(
                                                                "mdi-arrow-left"
                                                              )
                                                            ])
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            "\n                        Change Provider\n                      "
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              {
                                                attrs: {
                                                  xs6: "",
                                                  "text-xs-right": ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticClass: "my-0",
                                                    attrs: {
                                                      color: "secondary",
                                                      disabled: !_vm
                                                        .filteredStudents.length
                                                    },
                                                    on: {
                                                      click: _vm.onNextClicked
                                                    }
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        "\n                        Create Service Log\n                      "
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      { staticClass: "pl-2" },
                                                      [
                                                        _c("v-icon", [
                                                          _vm._v(
                                                            "mdi-arrow-right"
                                                          )
                                                        ])
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-alert",
                              { attrs: { value: _vm.errMsg, type: "error" } },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.errMsg) +
                                    "\n          "
                                )
                              ]
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isMobile
        ? _c(
            "v-card",
            { staticStyle: { overflow: "hidden" } },
            [
              _c(
                "v-toolbar",
                { attrs: { color: "primary", dark: "" } },
                [
                  _c("v-toolbar-title", [
                    _vm.isAdmin && !_vm.showSelectStudents
                      ? _c("span", [
                          _vm._v("\n          Select Provider\n        ")
                        ])
                      : _c("span", [
                          _vm._v("\n          Select Student\n          "),
                          !_vm.isMobile
                            ? _c("span", [
                                _vm._v("\n            Service\n          ")
                              ])
                            : _vm._e()
                        ])
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _vm.showSelectStudents
                    ? _c(
                        "div",
                        { staticStyle: { "padding-top": "20px" } },
                        [
                          _c(
                            "v-tooltip",
                            { attrs: { disabled: !_vm.showTooltip, top: "" } },
                            [
                              _c(
                                "v-switch",
                                {
                                  attrs: { slot: "activator" },
                                  slot: "activator",
                                  model: {
                                    value: _vm.allSupportsToggle,
                                    callback: function($$v) {
                                      _vm.allSupportsToggle = $$v
                                    },
                                    expression: "allSupportsToggle"
                                  }
                                },
                                [
                                  _c("template", { slot: "label" }, [
                                    _c(
                                      "span",
                                      {
                                        class: {
                                          "accent--text font-weight-bold":
                                            _vm.allSupportsToggle,
                                          small: _vm.isMobile
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  All Services\n                "
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v("View Current Services or All Services")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isMobile
                    ? _c(
                        "span",
                        { staticClass: "ml-2" },
                        [
                          _c(
                            "v-icon",
                            {
                              on: {
                                click: function($event) {
                                  _vm.dialog = false
                                }
                              }
                            },
                            [_vm._v("close")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.isAdmin && !_vm.showSelectStudents
                ? [
                    _c(
                      "v-card-text",
                      [
                        _c(
                          "v-layout",
                          {
                            attrs: {
                              row: "",
                              "justify-center": "",
                              "align-center": ""
                            }
                          },
                          [
                            _c(
                              "v-flex",
                              { attrs: { xs12: "", sm6: "" } },
                              [
                                _c(
                                  "v-autocomplete",
                                  {
                                    attrs: {
                                      dense: "",
                                      label: "Provider Name/Credentials",
                                      placeholder: "Enter Provider",
                                      items: _vm.providersArray,
                                      clearable: true,
                                      "error-messages": _vm.providerSearchError,
                                      "return-object": true,
                                      "search-input": _vm.providerSearchInput,
                                      "item-text": "username",
                                      loading: _vm.providerSearchLoading,
                                      "no-filter": true
                                    },
                                    on: {
                                      "update:searchInput": function($event) {
                                        _vm.providerSearchInput = $event
                                      },
                                      "update:search-input": function($event) {
                                        _vm.providerSearchInput = $event
                                      },
                                      focus: _vm.clearProvidersAutoComplete
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "item",
                                          fn: function(ref) {
                                            var item = ref.item
                                            var tile = ref.tile
                                            return [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(item.firstName) +
                                                  " " +
                                                  _vm._s(item.lastName) +
                                                  "\n                "
                                              ),
                                              _vm._v(" "),
                                              item.credentialName
                                                ? _c("span", [
                                                    _vm._v(
                                                      "/" +
                                                        _vm._s(
                                                          item.credentialName
                                                        )
                                                    )
                                                  ])
                                                : _vm._e()
                                            ]
                                          }
                                        },
                                        {
                                          key: "selection",
                                          fn: function(ref) {
                                            var item = ref.item
                                            var selected = ref.selected
                                            return [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(item.firstName) +
                                                  " " +
                                                  _vm._s(item.lastName) +
                                                  "\n                "
                                              ),
                                              _vm._v(" "),
                                              item.credentialName
                                                ? _c("span", [
                                                    _vm._v(
                                                      "/" +
                                                        _vm._s(
                                                          item.credentialName
                                                        )
                                                    )
                                                  ])
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3578212865
                                    ),
                                    model: {
                                      value: _vm.selectedProvider,
                                      callback: function($$v) {
                                        _vm.selectedProvider = $$v
                                      },
                                      expression: "selectedProvider"
                                    }
                                  },
                                  [
                                    _vm._v(" "),
                                    _vm._v(" "),
                                    _c(
                                      "template",
                                      { slot: "no-data" },
                                      [
                                        _c(
                                          "v-list",
                                          [
                                            !_vm.providerSearchInput
                                              ? _c("v-list-tile", [
                                                  _vm._v(
                                                    "\n                    Please type a Provider.\n                  "
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.providerSearchInput &&
                                            !_vm.providerSearchLoading
                                              ? _c("v-list-tile", [
                                                  _vm._v(
                                                    "\n                    No Results\n                  "
                                                  )
                                                ])
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-layout",
                          { attrs: { "justify-end": "" } },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "secondary",
                                  disabled: !_vm.selectedProvider
                                },
                                on: { click: _vm.goToSelectStudents }
                              },
                              [
                                _vm._v(
                                  "\n            Select Student\n            "
                                ),
                                _c(
                                  "span",
                                  { staticClass: "pl-2" },
                                  [_c("v-icon", [_vm._v("mdi-arrow-right")])],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              !_vm.isAdmin || (_vm.showSelectStudents && _vm.isAdmin)
                ? _c("span", [
                    _c(
                      "div",
                      [
                        _c(
                          "v-container",
                          [
                            _c(
                              "v-layout",
                              { attrs: { row: "", wrap: "" } },
                              [
                                _c(
                                  "v-flex",
                                  {
                                    class: { "pa-0": _vm.isMobile },
                                    attrs: { xs12: "", sm4: "" }
                                  },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: "Find Student",
                                        placeholder: "Enter Student",
                                        clearable: true
                                      },
                                      model: {
                                        value: _vm.findStudentSearch,
                                        callback: function($$v) {
                                          _vm.findStudentSearch = $$v
                                        },
                                        expression: "findStudentSearch"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    class: { "pa-0": _vm.isMobile },
                                    attrs: { xs12: "", sm4: "" }
                                  },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: "Filter School",
                                        placeholder: "Enter School",
                                        clearable: true
                                      },
                                      model: {
                                        value: _vm.findSchoolSearch,
                                        callback: function($$v) {
                                          _vm.findSchoolSearch = $$v
                                        },
                                        expression: "findSchoolSearch"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    class: { "pa-0": _vm.isMobile },
                                    attrs: { xs12: "", sm4: "" }
                                  },
                                  [
                                    _c(
                                      "v-layout",
                                      { attrs: { row: "", wrap: "" } },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { xs12: "" } },
                                          [
                                            _c(
                                              "v-menu",
                                              {
                                                staticStyle: { width: "100%" },
                                                attrs: { "offset-y": "" }
                                              },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      slot: "activator",
                                                      color: "secondary",
                                                      block: ""
                                                    },
                                                    slot: "activator"
                                                  },
                                                  [_c("span", [_vm._v("Sort")])]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-list",
                                                  [
                                                    _c(
                                                      "v-list-tile",
                                                      [
                                                        _c(
                                                          "v-list-tile-title",
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.sort =
                                                                  "lastNameAsc"
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            Last Name Asc\n                          "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-list-tile",
                                                      [
                                                        _c(
                                                          "v-list-tile-title",
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.sort =
                                                                  "lastNameDesc"
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            Last Name Desc\n                          "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-list-tile",
                                                      [
                                                        _c(
                                                          "v-list-tile-title",
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.sort =
                                                                  "schoolAsc"
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            School Name Asc\n                          "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-list-tile",
                                                      [
                                                        _c(
                                                          "v-list-tile-title",
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.sort =
                                                                  "schoolDesc"
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            School Name Desc\n                          "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-list-tile",
                                                      [
                                                        _c(
                                                          "v-list-tile-title",
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.sort =
                                                                  "latestService"
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            Last Service\n                          "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { xs12: "" } },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  color: "secondary",
                                                  block: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    _vm.checkAllBoxes = !_vm.checkAllBoxes
                                                  }
                                                }
                                              },
                                              [
                                                !_vm.checkAllBoxes
                                                  ? _c("span", [
                                                      _vm._v("Select All")
                                                    ])
                                                  : _c("span", [
                                                      _vm._v("Deselect All")
                                                    ])
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "select-student-content pb-5" },
                      [
                        _c(
                          "v-container",
                          { attrs: { "text-xs-left": "", "pa-0": "" } },
                          [
                            _c(
                              "v-alert",
                              {
                                attrs: {
                                  value: !_vm.filteredStudents.length,
                                  type: "error"
                                }
                              },
                              [
                                _vm._v(
                                  "\n              No Students associated with this provider.\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.filteredStudents.length
                              ? _c("v-data-table", {
                                  attrs: {
                                    items: _vm.filteredStudents,
                                    "hide-actions": "",
                                    "hide-headers": ""
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "items",
                                        fn: function(props) {
                                          return [
                                            _c(
                                              "td",
                                              {
                                                class: { "pa-2": _vm.isMobile }
                                              },
                                              [
                                                _c("v-checkbox", {
                                                  attrs: {
                                                    color: "secondary",
                                                    "hide-details": ""
                                                  },
                                                  model: {
                                                    value: props.item.selected,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        props.item,
                                                        "selected",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "props.item.selected"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _vm.isMobile
                                              ? _c(
                                                  "td",
                                                  { staticClass: "py-1 px-0" },
                                                  [
                                                    _c("strong", [
                                                      _c("span", [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              props.item
                                                                .studentName
                                                            ) +
                                                            "\n                      (" +
                                                            _vm._s(
                                                              props.item
                                                                .studentExtId
                                                            ) +
                                                            ")\n                    "
                                                        )
                                                      ])
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      { staticClass: "pr-1" },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              props.item
                                                                .schoolName
                                                            ) +
                                                            "\n                  "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          props.item.grade
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm._f("formatDate")(
                                                            props.item.startDate
                                                          )
                                                        ) +
                                                        " - " +
                                                        _vm._s(
                                                          _vm._f("formatDate")(
                                                            props.item.endDate
                                                          )
                                                        )
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          props.item.frequency
                                                        ) +
                                                        " "
                                                    ),
                                                    props.item.esy
                                                      ? _c("span", [
                                                          _vm._v("(ESY)")
                                                        ])
                                                      : _vm._e()
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !_vm.isMobile
                                              ? _c(
                                                  "td",
                                                  {
                                                    class: {
                                                      "warning--text": !props
                                                        .item.active
                                                    }
                                                  },
                                                  [
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          props.item.studentName
                                                        )
                                                      )
                                                    ]),
                                                    _c("br"),
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          props.item
                                                            .studentExtId
                                                        ) +
                                                        "\n                "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !_vm.isMobile
                                              ? _c(
                                                  "td",
                                                  {
                                                    class: {
                                                      "warning--text": !props
                                                        .item.active
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          props.item.schoolName
                                                        )
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          props.item.grade
                                                        ) +
                                                        "\n                "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !_vm.isMobile
                                              ? _c(
                                                  "td",
                                                  {
                                                    class: {
                                                      "warning--text": !props
                                                        .item.active
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm._f("formatDate")(
                                                            props.item.startDate
                                                          )
                                                        ) +
                                                        " - " +
                                                        _vm._s(
                                                          _vm._f("formatDate")(
                                                            props.item.endDate
                                                          )
                                                        )
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          props.item.frequency
                                                        ) +
                                                        " "
                                                    ),
                                                    props.item.esy
                                                      ? _c("span", [
                                                          _vm._v("(ESY)")
                                                        ])
                                                      : _vm._e()
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    1374639330
                                  )
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "footer" },
                      [
                        _c(
                          "v-layout",
                          { staticStyle: { width: "100%", margin: "0" } },
                          [
                            _c(
                              "v-flex",
                              { staticClass: "block", attrs: { xs12: "" } },
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs6: "" } },
                                      [
                                        _vm.isAdmin
                                          ? _c(
                                              "v-btn",
                                              {
                                                staticClass: "my-0",
                                                attrs: {
                                                  color: "secondary",
                                                  block: _vm.isMobile
                                                },
                                                on: {
                                                  click: _vm.returnToProviders
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    class: {
                                                      "small pt-1": _vm.isMobile
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "pr-2" },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              small:
                                                                _vm.isMobile
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-arrow-left"
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(
                                                      "\n                  Change Provider\n                  "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      {
                                        attrs: { xs6: "", "text-xs-right": "" }
                                      },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass: "my-0",
                                            attrs: {
                                              color: "secondary",
                                              block: _vm.isMobile,
                                              disabled: !_vm.filteredStudents
                                                .length
                                            },
                                            on: { click: _vm.onNextClicked }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                class: {
                                                  "small pt-1": _vm.isMobile
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Create Service Log\n                  "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "pl-2" },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      small: _vm.isMobile
                                                    }
                                                  },
                                                  [_vm._v("mdi-arrow-right")]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showLoading ? _c("full-screen-loading-spinner") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bafdc6aa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bafdc6aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/select-student-dialog.vue
// module id = null
// module chunks = 